import { apiClient } from './apiClient';
import { ChatDetail, ChatSummary, MessagePairResponse } from '../domain';

export async function fetchChats(headers: Record<string, string>): Promise<ChatSummary[]> {
  const response = await apiClient.get<ChatSummary[]>('/chats', { headers });
  return response.data;
}

export async function fetchChatDetail(
  chatId: number,
  headers: Record<string, string>
): Promise<ChatDetail> {
  const response = await apiClient.get<ChatDetail>(`/chats/${chatId}`, { headers });
  return response.data;
}

export async function createChat(
  agentId: string,
  headers: Record<string, string>
): Promise<ChatSummary> {
  const response = await apiClient.post<ChatSummary>(
    '/chats',
    {
      agent_id: agentId,
      title: 'New Chat',
    },
    { headers }
  );
  return response.data;
}

export async function sendMessage(
  chatId: number,
  content: string,
  headers: Record<string, string>
): Promise<MessagePairResponse> {
  const response = await apiClient.post<MessagePairResponse>(
    `/chats/${chatId}/messages`,
    { content },
    { headers }
  );
  return response.data;
}
